import {
  ICriteria,
  IS2SFlowTemplate,
  IS2SFlowTemplateForm,
  IS2SFlowTemplatePayload,
} from '~/connect/types';

export function fromFormToPayload(
  data: IS2SFlowTemplateForm,
  criteria: ICriteria[],
): IS2SFlowTemplatePayload {
  const { businessRules, newFlowType, newFlowPartner, ...rest } = data;

  return {
    ...rest,
    criteria: data.criteria.map(({ criterion, values }) => ({
      criterion,
      values:
        criteria
          .find((c) => c.id === criterion.id)
          ?.values.filter((value) =>
            values.some((selectedValueId) => selectedValueId === value.id),
          ) ?? [],
    })),
    businessRules: businessRules.map(({ id, parameters }) => ({
      rule: { id },
      parameters: Object.entries(parameters).map(([key, value]) => ({
        key,
        value,
      })),
    })),
  };
}

export function toFormData(template: IS2SFlowTemplate): IS2SFlowTemplateForm {
  return {
    name: template.name,
    flows: template.flows,
    businessRules: (template.businessRules ?? []).map((r) => ({
      id: r.rule.id,
      parameters: Object.fromEntries(
        (r.parameters ?? []).map(({ key, value }) => [key, value]),
      ),
    })),
    criteria: template.criteria.map(({ criterion, values }) => ({
      criterion,
      values: values.map((value) => value.id),
    })),
    newFlowType: '',
    newFlowPartner: '',
  };
}

export const S2S_FLOW_TEMPLATE_FORM_DEFAULT_VALUES: IS2SFlowTemplateForm = {
  name: '',
  criteria: [],
  flows: [],
  businessRules: [],
  newFlowType: '',
  newFlowPartner: '',
};
